import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
// import { NgbPaginationModule, NgbModalModule, NgbTypeaheadModule, NgbDatepickerModule, NgbPopoverModule, NgbDropdownModule, NgbTooltipModule, NgbNavModule, NgbButtonsModule } from "@ng-bootstrap/ng-bootstrap";
//import { NgSelectModule } from "@ng-select/ng-select";

import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { OAuthModule } from 'angular-oauth2-oidc';
import * as echarts from 'echarts';
import { NgChartsModule } from 'ng2-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AdminBuyersCaddyApiModule } from "src/portal/admin-buyerscaddy-api/admin-buyers-caddy-api.module";
import { AiProxyApiModule } from "src/portal/ai-proxy-api/ai-proxy-api.module";
import { BuyersCaddyApiModule } from "src/portal/buyerscaddy-api/buyers-caddy-api.module";
import { CompanyApiModule } from 'src/portal/company-api/company-api.module';
import { ContactApiModule } from 'src/portal/contact-api/contact-api.module';
import { PublicApiModule } from "src/portal/public-api/public-api.module";
import { SearchApiModule } from 'src/portal/search-api/search-api.module';
import { StorageApiModule } from "src/portal/storage-api/storage-api.module";
import { UserApiModule } from "src/portal/user-api/user-api.module";
import { EffectsConfiguration } from "src/storage/effects-configuration";
import { CustomRouterSerializer } from "src/storage/router/router.reducers";
import { ConnectionsApiModule } from '../../portal/connections-api/connections-api.module';
import { MeetingApiModule } from "../../portal/meeting-api/meeting-api.module";
import { OrgChartApiModule } from '../../portal/orgchart-api/org-chart-api.module';
import { PointsApiModule } from '../../portal/points-api/points-api.module';
import { SurveyApiModule } from "../../portal/survey-api/survey-api.module";
import { UserProfileApiModule } from "../../portal/user-profile-api/user-profile-api.module";
import {
  ReducerConfiguration,
  ReducerMap,
} from '../../storage/reducer-configuration';
import { HeaderInterceptor } from "./interceptors/header-interceptor.";
import { ResponseInterceptor } from "./interceptors/response-interceptor";
import { MaterialModule } from "./material/material.module";
import { AuthService } from "./services/auth.service";


@NgModule({
    imports: [
        MaterialModule,
        NgxEchartsModule.forRoot({echarts}),
        ToastrModule.forRoot(),
        HttpClientModule,
        NgChartsModule,
        StoreModule.forRoot(ReducerMap, ReducerConfiguration),
        EffectsModule.forRoot(EffectsConfiguration),
        StoreRouterConnectingModule.forRoot({
            serializer: CustomRouterSerializer,
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 50,
            logOnly: environment.production,
        }),

        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [
                    environment.newsApiRootUrl + '/api/feed/news',
                    environment.userProfileApiRootUrl,
                    environment.meetingApiRootUrl,
                    environment.surveyApiRootUrl,
                    environment.searchApiRootUrl,
                    environment.contactApiRootUrl,
                    environment.pointsApiRootUrl,
                    environment.companyApiRootUrl,
                    environment.orgchartApiRootUrl,
                    environment.connectionsApiRootUrl,
                    environment.buyersCaddyApiRootUrl,
                    environment.adminBuyersCaddyApiRootUrl,
                    environment.userApiRootUrl,
                    environment.storageApiRootUrl,
                    environment.aiProxyApiRootUrl,
                    environment.publicApiRootUrl,
                ],
                sendAccessToken: true,
            },
        }),
        StorageApiModule.forRoot({rootUrl:environment.storageApiRootUrl}),
        UserProfileApiModule.forRoot({rootUrl:environment.userProfileApiRootUrl}),
        MeetingApiModule.forRoot({ rootUrl: environment.meetingApiRootUrl }),
        SurveyApiModule.forRoot({ rootUrl: environment.surveyApiRootUrl }),
        SearchApiModule.forRoot({ rootUrl: environment.searchApiRootUrl }),
        ContactApiModule.forRoot({ rootUrl: environment.contactApiRootUrl }),
        PointsApiModule.forRoot({ rootUrl: environment.pointsApiRootUrl }),
        CompanyApiModule.forRoot({ rootUrl: environment.companyApiRootUrl }),
        OrgChartApiModule.forRoot({ rootUrl: environment.orgchartApiRootUrl }),
        ConnectionsApiModule.forRoot({ rootUrl: environment.connectionsApiRootUrl }),
        BuyersCaddyApiModule.forRoot({ rootUrl: environment.buyersCaddyApiRootUrl }),
        AdminBuyersCaddyApiModule.forRoot({ rootUrl: environment.adminBuyersCaddyApiRootUrl }),
        UserApiModule.forRoot({rootUrl: environment.userApiRootUrl}),
        AiProxyApiModule.forRoot({rootUrl: environment.aiProxyApiRootUrl}),
        PublicApiModule.forRoot({rootUrl: environment.publicApiRootUrl})
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: (authService: AuthService) => {
                return async () => {

                    await authService.configure();

                    if (location.search.match(/state=/)) {
                        return authService.validateToken().then((result) => {
                            return result ? null : new Promise(() => {});
                        });
                    } else {
                        return true;
                    }
                };
            },
            deps: [AuthService],
            multi: true,
        },
    ],
})
export class CoreModule {

}
